// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__FFOZn","productName":"Table_productName__1wMzP"};